<template>
    <b-card>
        <b-card-body :title="title">
            <b-form @submit.stop.prevent="onSubmit">
                <b-form-group
                    id="name-group"
                    label="Name"
                    label-for="input-name"
                    label-cols="4"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-input
                        type="text"
                        id="input-name"
                        v-model="model.name"
                        required
                        placeholder="Enter Name"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="description-group"
                    label="Description"
                    label-for="input-description"
                    label-cols="4"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-input
                        type="text"
                        id="input-description"
                        v-model="model.description"
                        required
                        placeholder="Enter Description"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="reasons-group"
                    label="Reasons"
                    label-for="input-reasons"
                    label-cols="4"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-input
                        type="text"
                        id="input-reasons"
                        v-model="model.reasons"
                        required
                        placeholder="Enter Reasons"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="role_id-group"
                    label="Role:"
                    label-for="input-role_id"
                    label-cols="4"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-select
                        id="input-role_id"
                        v-model="model.role_id"
                        :options="roles"
                        text-field="name"
                        value-field="id"
                        trim
                    >
                        <template #first>
                            <b-form-select-option :value="null"
                                >-- No Role --</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                </b-form-group>

                <b-button
                    variant="secondary"
                    :disabled="loading ? true : false"
                    @click="cancel()"
                    >Cancel</b-button
                >
                <b-button
                    type="submit"
                    variant="primary"
                    :disabled="loading ? true : false"
                    >{{ submitLabel }}</b-button
                >
                <b-button
                    v-if="model.id"
                    @click="deleteCheckoffType()"
                    variant="warning"
                >
                    Delete
                </b-button>
            </b-form>
        </b-card-body>
    </b-card>
</template>
<script>
export default {
    name: 'view-item',
    data() {
        return {
            loading: false,
            model: {
                id: 0,
                name: null,
                description: null,
                reasons: null,
                role_id: null,
            },
            updating: false,
            submitting: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        title() {
            return this.model.id ? 'Review Type' : 'Create Review Type'
        },
        roles() {
            return this.$store.state.roles.items
        },

        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = this.item
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }
            console.log('model', model)
            const path = model.id
                ? 'checkoffTypes/update'
                : 'checkoffTypes/create'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            const message = model.id ? 'Updated' : 'Created'
                            this.$emit('success', message)
                        })
                        .catch(error => {
                            console.log('error', error)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },

        deleteCheckoffType() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'checkoffTypes/delete'

            // Generate and display confirmation prompt
            const title = 'Delete Checkoff Type?'
            const message = `Are you sure you want to delete ${model.name}?`
            const errorMsg = 'Unable to delete Checkoff Type!'

            this.$emit(
                'delete-item',
                message,
                title,
                model.id,
                () => {
                    this.$emit('success', 'Deleted')
                },
                path,
                errorMsg
            )
        },
    },
}
</script>
<style></style>
